export const VEHICLES_PATH = "/vehicles";

/** `/vehicles?branch_uuid=<uuid>` opens the page on that branch for MASTER / ADMIN, e.g. from a branch's page. */
export const VEHICLE_BRANCH_QUERY_KEY = "branch_uuid";
